import { Experience } from '../../pages/experiences/experiences/experience.model';


export class LocationCollection {
  total: number;
  locations: Location[];
}

export class Location {
  id: number;
  name: string;
  country: string;
  experiences?: Experience[];

  constructor(values: any = {}) {
    Object.assign(this, values);
  }

  getName() {
    if (this['experiences']) {
      return this.name;
    }
    return this.name;
  }

  getNameAndEventCount() {
    if (this['experiences']) {
      return this.name + ' (' + this.experiences.length + ')';
    }
    return this.name;
  }
}
